import s from "./_getMapData.js";
var r = s;
function p(t, e) {
  var a = r(this, t), i = a.size;
  return a.set(t, e), this.size += a.size == i ? 0 : 1, this;
}
var m = p;
export {
  m as default
};
//# sourceMappingURL=_mapCacheSet.js.map
